// extracted by mini-css-extract-plugin
export var avatarContainer = "_9r-0";
export var avatarTypingWave = "_9r-i";
export var gray = "_9r-f";
export var green = "_9r-c";
export var icon = "_9r-9";
export var image = "_9r-1";
export var lg = "_9r-6";
export var md = "_9r-5";
export var presenceDot = "_9r-b";
export var red = "_9r-d";
export var sm = "_9r-4";
export var status = "_9r-a";
export var typingDot = "_9r-h";
export var typingPill = "_9r-g";
export var xl = "_9r-7";
export var xs = "_9r-3";
export var xxl = "_9r-8";
export var xxs = "_9r-2";
export var yellow = "_9r-e";